var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-status-step"},[_c('el-steps',{attrs:{"active":_vm.activeIndex,"finish-status":"success","align-center":""}},_vm._l((this.showStatusList),function(status){return _c('el-step',{key:status.key,attrs:{"title":status.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }